import { render } from "./HistoryViewComponent.vue?vue&type=template&id=21c3f50e"
import script from "./HistoryViewComponent.vue?vue&type=script&lang=js"
export * from "./HistoryViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__